import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Blog from "../components/Blog";


const BlogListPage = () => {
    return (
        <>
            <Navbar/>
            <Blog />
            <Footer/>
        </>
    );
}

export default BlogListPage;